import { u as t } from "./snackbarProvider-078e9a24.mjs";
import { S as z } from "./snackbarProvider-078e9a24.mjs";
import { jsx as i } from "react/jsx-runtime";
import { Button as m } from "./button.js";
import "react";
import "./index-6a632112.mjs";
import "react-dom";
import "./themes-5f0b3c3d.mjs";
import "./zIndices-d07533f3.mjs";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
const h = ({ snackbar: r }) => {
  const { addSnackBar: o } = t();
  return /* @__PURE__ */ i(m, { onClick: () => o(r), size: "small", variant: "solid", children: "Snackbar" });
};
export {
  z as SnackbarProvider,
  h as SnackbarStory,
  t as useSnackbars
};
